import React, { Component, Fragment } from 'react';
import { __, __n } from 'i18n-for-browser';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Scrollbar from 'react-scrollbars-custom';

import noAvatar from '../../assets/img/icons/avatar.svg';

import GoBackButton from '../elements/GoBackButton';
import ContentContainer from '../elements/ContentContainer';
import Table from '../elements/Table';
import SectionHeading from "../elements/SectionHeading";
import StatusBox from "../elements/StatusBox";
import Defines from "../../Defines";
import apiCall from '../apiCall';

import actions from '../../actions';
import { icons } from '../../assets/assets';
import { getGameStateSum } from '../../helpers/gameStateHelpers';
import { getMinistryColor } from '../../helpers/feedbackHelpers';
import { getGroupAvatarUrl } from '../../helpers/groupHelper';
import imageResizer from '../../helpers/imageResizer';

import config from '../../config';
import PopUp from "../elements/PopUp";
import objectChanged from '../../helpers/objectChanged';
import getUrlVars from '../../helpers/getUrlVars';

const { setGroupId } = actions.schoolClass;

class TeamInfo extends Component {
  static propTypes = {
    history: PropTypes.shape({
      goBack: PropTypes.func,
    }).isRequired,
  };

  constructor(props) {
    super(props);
    this.groupId = props.match.params.groupId;
    if (this.groupId) {
      props.dispatch(setGroupId(this.groupId));
    }
    this.state = {
      group: props.group,
      myDetailedRank: [],
      submittingGroup: false,
      submittedAvatar: false,
      submittedName: false,
      uploadingAvatar: false,
      avatarChanged: false,
      nameChanged: false,
      showPopup: false,
      popupId: null,
      errorMessage: undefined,
    };
    this.ministries = {};

    this.fileUploadRef = React.createRef();
  }

  componentWillMount() {
    this.props.dispatch(actions.project.refreshProject());
    apiCall('/group/myDetailedRank?includeBonusPoints=true', null, 'GET')
      .then((myDetailedRank) => {
        this.setState({
          myDetailedRank,
        });
      });
    Defines.fetch()
      .then((defines) => {
        this.setState({ defines });
      });
  }

  componentWillReceiveProps(props) {
    if (this.groupId && props.group.id !== this.state.group.id) {
      props.dispatch(setGroupId(this.groupId));
    }
    if (!this.state.group.loaded) {
      this.setState({
        group: props.group,
      });
    }
    if (props.user.role === 'classleader') {
      const scGroup = props.schoolClass.group;
      if (scGroup && this.state.group.id !== scGroup.id) {
        this.setState({
          group: scGroup,
        });
      }
    }
    if (objectChanged(this.state.group, props.group)) {
      this.setState({
        group: props.group,
      });
    }
  }

  handleChange = ({ target: { value, name } }) => {
    if (this.props.user.role.indexOf('leader') === -1 || !this.allowUpdateName()) return false;
    if (name === 'name') value = value.toUpperCase();
    const state = this.state;
    if (value.length < 17) {
      state.group[name] = value;
      state.nameChanged = true;
      state.submittedName = false;
      this.setState(state);
    }
  };

  getValueFromRound = (roundNumber, keyName, gameStateFilter) => {
    const round = this.state.group.Rounds.find(r => r.roundNumber === roundNumber);
    if (round) {
      if (['AB_points', 'BB_points'].includes(keyName) && !['SIMULATION_TAX_2', 'SIMULATION_SPENDING', 'END'].includes(round.state)) return '';
      if (['C_points', 'V_points', 'VV_points'].includes(keyName) && !['SIMULATION_SPENDING', 'END'].includes(round.state)) return '';
      if (['pc_points'].includes(keyName) && !['END'].includes(round.state)) return '';
      if (gameStateFilter === 'POLICY_CHOICE' && keyName === 'points' && round.state !== 'END') return '';
      if (gameStateFilter) {
        const sum = getGameStateSum(round.GameStates.filter(gs => gs.state === gameStateFilter));
        return sum[keyName] || 0;
      }
      return round.gameStateSum[keyName] || 0;
    }
    return '';
  };

  getValueFromRoundForMinistry = (roundNumber, keyName, gameStateFilter) => {
    const nextRound = this.state.group.Rounds.find(r => r.roundNumber === roundNumber + 1);
    if (nextRound && (nextRound.state.startsWith('SIMULATION_') || nextRound.state === 'END')) {
      return this.getValueFromRound(roundNumber, keyName, gameStateFilter);
    }
    return '';
  };

  renderTaxScores = () => {
    if (this.props.project.difficulty === 'PRO') {
      return [
        [__('sim_arbeidsbelasting'), '', this.getValueFromRound(1, 'AB_points'), this.getValueFromRound(2, 'AB_points'), this.getValueFromRound(3, 'AB_points'), this.getValueFromRound(4, 'AB_points')],
        [__('sim_bedrijvenbelasting'), '', this.getValueFromRound(1, 'BB_points'), this.getValueFromRound(2, 'BB_points'), this.getValueFromRound(3, 'BB_points'), this.getValueFromRound(4, 'BB_points')],
        [__('sim_consumentenbelasting'), '', this.getValueFromRound(1, 'C_points'), this.getValueFromRound(2, 'C_points'), this.getValueFromRound(3, 'C_points'), this.getValueFromRound(4, 'C_points')],
        [__('sim_mensmilieubelasting'), '', this.getValueFromRound(1, 'VV_points'), this.getValueFromRound(2, 'VV_points'), this.getValueFromRound(3, 'VV_points'), this.getValueFromRound(4, 'VV_points')],
        [__('sim_vermogenbelasting'), '', this.getValueFromRound(1, 'V_points'), this.getValueFromRound(2, 'V_points'), this.getValueFromRound(3, 'V_points'), this.getValueFromRound(4, 'V_points')],
      ];
    }
    const rows = [
      [__('sim_belasting'), '', this.getValueFromRound(1, 'AB_points'), this.getValueFromRound(2, 'AB_points'), this.getValueFromRound(3, 'AB_points'), this.getValueFromRound(4, 'AB_points')],
    ];
    if (this.props.project.minPolicyChoices > 0) {
      rows.push([__n('sim_beleidskeuze', 0), '', this.getValueFromRound(1, 'pc_points'), this.getValueFromRound(2, 'pc_points'), this.getValueFromRound(3, 'pc_points'), this.getValueFromRound(4, 'pc_points')]);
    }
    return rows;
  };

  getColor = (ministry, roundNumber = 0) => {
    const { project, gameStateInput, feedback, gameState } = this.props;
    const { group } = this.state;
    if (gameState.Rounds.length <= roundNumber) return '';
    const currentRound = gameState.Rounds.find(r => r.roundNumber === roundNumber);
    const nextRound = gameState.Rounds.find(r => r.roundNumber === roundNumber + 1);
    if (!currentRound) return '';
    if (roundNumber > 0 && (!nextRound || nextRound.state === 'PLAYING_GAME' || nextRound.state === 'SCORE_SUBMITTED')) return '';
    const fb = (!feedback.all.length ? [] : feedback.all[roundNumber] || {}).feedback || [];
    const gs = {
      sumUpToPrevRound: getGameStateSum(
        gameState.Rounds
          .slice(0, roundNumber + 1)
          .reduce((acc, r) => acc.concat(r.GameStates), [])
      ),
      currentRound: roundNumber,
    };
    let ministryCollaborations = {};
    if (gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling) {
      const selectedCollabs = gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling[`${ministry}SW`] || [];
      const myTheme = gameStateInput.states[roundNumber][group.id].theme;
      const myValue = gameStateInput.states[roundNumber][group.id].ministerieGlobaVerdeling[ministry];
      ministryCollaborations = {
        [ministry]: selectedCollabs.filter((theme) => {
          const otherGroup = Object.values(gameStateInput.states[roundNumber])
            .find(g => g.theme === theme);
          return (otherGroup && otherGroup.ministerieGlobaVerdeling && myValue === otherGroup.ministerieGlobaVerdeling[ministry] && (otherGroup.ministerieGlobaVerdeling[`${ministry}SW`] || []).includes(myTheme));
        }),
      };
    }
    return getMinistryColor(project.difficulty.toLowerCase(), ministry, gs, { ministryCollaborations }, fb, true);
  };

  renderMinistryScores = () => {
    return this.ministries.map((m) => {
      return [
        m,
        <StatusBox status={this.getColor(m, 0)} />,
        <StatusBox status={this.getColor(m, 1)} text={this.getValueFromRoundForMinistry(1, `${m}_points`)} />,
        <StatusBox status={this.getColor(m, 2)} text={this.getValueFromRoundForMinistry(2, `${m}_points`)} />,
        <StatusBox status={this.getColor(m, 3)} text={this.getValueFromRoundForMinistry(3, `${m}_points`)} />,
        <StatusBox status={this.getColor(m, 4)} text={this.getValueFromRoundForMinistry(4, `${m}_points`)} />,
      ];
    });
  };

  uploadAvatar = async (file) => {
    const { group, uploadingAvatar } = this.state;
    if (uploadingAvatar) return null;
    this.setState({ uploadingAvatar: true, avatarChanged: true, submittedAvatar: false });
    const formData = new FormData();
    const fileName = `${this.props.schoolClass.className}-${this.props.schoolClass.classRoom}-${__(this.props.group.GroupTheme.color).toUpperCase()}`.replace(/[^a-z0-9]/gi, '_') + ".jpeg";
    const resized = await imageResizer(file, 500, 500, 0.8, fileName);
    formData.append('file', resized, resized.name);
    apiCall('/file/upload', formData, 'POST')
      .then((f) => {
        if (f[0]) {
          group.Avatar = f[0];
          group.AvatarId = f[0].id;
          this.setState({ group, uploadingAvatar: false });
        }
      })
      .catch(() => {
        this.setState({ uploadingAvatar: false, avatarChanged: false, errorMessage: __('sim_fout_uploaden_groeps_foto') }, () => {
          if (this.timeout)
            clearTimeout(this.timeout);
          this.timeout = setTimeout(() => {
            this.setState({ errorMessage: undefined });
          }, 7000);
        });
      });
  };

  openPopup = (id = null, callback = null) => {
    this.setState({
      popupId: id,
      showPopup: true,
      popupCallBack: callback,
    })
  }

  closePopup = (executeCallBack = true) => {
    this.setState({
      popupId: null,
      showPopup: false,
    })
    if (this.state.popupCallBack !== null && executeCallBack) {
      this.state.popupCallBack();
    }
  }

  popupBeforeSubmitGroup = () => {
    const { group } = this.state;
    if (this.props.user.role === 'classleader') return this.submitGroup();

    const nameChangedOnce = group.name !== __(group.GroupTheme.name);
    const avatarChangedOnce = group.AvatarId !== null;

    if (!avatarChangedOnce && !nameChangedOnce) {
      this.openPopup('dlgmopslaan')
    } else if (!avatarChangedOnce && nameChangedOnce) {
      this.openPopup('dlgmopslaanfoto', this.submitGroup)
    } else if (avatarChangedOnce && !nameChangedOnce) {
      this.openPopup('dlgmopslaannaam');
    } else {
      this.submitGroup();
    }
  };

  submitGroup = () => {
    if (this.state.submittingGroup) return;
    const { user } = this.props;
    this.setState({ submittingGroup: true });
    if (user.role.indexOf('leader') !== -1) {
      const { group } = this.state;
      if (this.state.nameChanged) {
        group.countrynameLocked = true;
      }
      if (this.state.avatarChanged) {
        group.avatarLocked = true;
      }
      apiCall(`/group/${group.id}/update`, group, 'PUT')
        .then((group) => {
          this.setState({ submittedName: this.state.nameChanged, submittedAvatar: this.state.avatarChanged, submittingGroup: false, group: { ...this.state.group, ...group } });
        });
      // this.props.dispatch(updateGroup({name: __(this.state.group.name)}));
    }
  };

  allowUpdateName = () => {
    if (this.props.user.role === 'classleader') return true;
    return this.props.user.role === 'groupleader' && !this.state.group.countrynameLocked;
  };

  toggleAvatarLocked = (ev) => {
    const { group } = this.state;
    if (ev !== false) ev.preventDefault();
    apiCall(`/group/${group.id}/setAvatarLocked`, !group.avatarLocked, 'PUT')
      .then((result) => {
        group.avatarLocked = result.avatarLocked;
        this.setState({ group });
      });
  };

  toggleCountrynameLocked = (ev) => {
    const { group } = this.state;
    if (ev !== false) ev.preventDefault();
    apiCall(`/group/${group.id}/setCountryNameLocked`, !group.countrynameLocked, 'PUT')
      .then((result) => {
        group.countrynameLocked = !group.countrynameLocked;
        this.setState({ group });
      });
  };

  studentNameUpdate = (ev, index) => {
    const { group } = this.state;
    if (!group.Students[index]) {
      group.Students[index] = { name: '' };
    }
    group.Students[index].name = ev.target.value;
    this.setState({ group });
  };

  studentNameBlur = (ev, index) => {
    if (this.props.user.role !== 'classleader') return;
    const { group } = this.state;
    if (!ev.target.value.length) {
      group.Students[index] = { name: '' };
    }
    const el = ev.currentTarget.parentElement;
    el.children[0].readOnly = true;
    el.classList.remove('hasFocus');
    apiCall(`/group/${group.id}/setStudents`, { students: group.Students.filter(s => s.name.length) }, 'PUT');
  };

  prefillScores = (body = []) => {
    while (body.length < 4) {
      body.push([
        [`${body.length + 1}. ${__('sim_verdienen')}`, '', '', '', ''],
        [`${body.length + 1}. ${__('sim_verdelen')}`, '', '', '', '']
      ]);
    }
    return body.slice(0, 4);
  };

  prefillScoresEarn = (body = []) => {
    while (body.length < 4) {
      body.push([`${body.length + 1}.`, '', '']);
    }
    return body;
  };

  checkShowPopup = () => {
    if (this.allowUpdateName() === false) {
      this.openPopup('dlgmnaamopgeslagen');
    }
  }

  renderStudentRows = () => {
    let students = [];
    while (students.length < 6) {
      const i = students.length;
      if (this.state.group.Students[i]) {
        students.push(this.state.group.Students[i]);
      } else {
        students.push({ name: '' });
      }
    }
    return students.map((s, i) => [
      <div onClick={(ev) => {
        const el = ev.currentTarget;
        el.children[0].readOnly = false;
        el.children[0].focus();
        el.classList.add('hasFocus');
      }} className={'student-container'}>
        <input
          style={{ width: '88%' }}
          key={i}
          ref={(() => {
            return this[`studentInputRef${i}`] = React.createRef();
          })()}
          onChange={(ev) => {
            this.studentNameUpdate(ev, i)
          }}
          value={s.name}
          maxLength={35}
          readOnly={true}
          onBlur={(ev) => {
            this.studentNameBlur(ev, i)
          }}
        />
        <img className="pen" src={icons.pen} alt={'pen'} />
      </div>
    ]);
  };

  render() {
    if (!this.state.group || !this.state.group.loaded || !this.state.defines) {
      return null;
    }
    this.ministries = this.state.defines[this.props.project.difficulty.toLowerCase()].ministries;
    let roundSpliceIndex = this.state.group.Rounds.findIndex(gr => gr.unsetScoreVisibility);
    if (roundSpliceIndex <= 0 || this.props.gameState.showScores) {
      roundSpliceIndex = this.state.group.Rounds.length;
    }
    return (
      <div className={'portal-home darkBckg'}>

        <div className={'portal-container teaminfo-container'}>

          <div className={`teaminfo ${this.props.user.role}`}>
            <div className={'close-button-container'}>
              <GoBackButton history={this.props.history} closeWindow={getUrlVars()['closeWindow'] === 'true'} />
            </div>
            <div className={'third'}>
              <Scrollbar style={{ width: '100%', height: '100%', minHeight: 300 }} >
                <div className={'container'}>
                  <ContentContainer className={"avatar-container"}>
                    <div className={`upload-avatar ${(this.state.uploadingAvatar ? 'disabled' : '')}`}>
                      <div className={'avatar-upload-wrapper'}>
                        {this.props.user.role === 'classleader' ? (
                          <div
                            className={`lock${this.state.group.avatarLocked ? ' locked' : ''}`}
                            onClick={this.toggleAvatarLocked}
                          />
                        ) : null}
                        {this.props.user.role === 'groupleader' && this.state.submittedAvatar ? (
                          <div className={'group-avatar-saved-check'} />
                        ) : null}
                        {this.props.user.role === 'groupleader' && !this.state.group.avatarLocked && !this.state.group.AvatarId ? (
                          <button>{__('sim_upload_foto_button')}</button>
                        ) : null}
                      </div>
                      <input
                        ref={this.fileUploadRef}
                        type={'file'}
                        disabled={this.props.user.role === 'classleader' ? false : this.state.group.avatarLocked}
                        name={'avatar'}
                        accept="image/png,image/jpeg"
                        onChange={(e) => {
                          this.uploadAvatar(e.target.files[0]);
                        }}
                      />
                      <img
                        id="team-avatar"
                        className={!this.state.group.Avatar ? 'no-avatar' : ''}
                        src={getGroupAvatarUrl(this.state.group, this.props.project, noAvatar)}
                        alt={'avatar'}
                        onClick={_ => this.openPopup('dlgmfotoopgeslagen')}
                      />
                    </div>
                    <form onSubmit={(ev) => { ev.preventDefault(); }}>
                      <div className="input-container" onClick={this.checkShowPopup}>
                        {this.props.user.role === 'classleader' ? (
                          <div
                            className={`lock text${this.state.group.countrynameLocked ? ' locked' : ''}`}
                            onClick={this.toggleCountrynameLocked}
                          />
                        ) : null}
                        {this.props.user.role === 'groupleader' && this.state.submittedName ? (
                          <div className={'group-name-saved-check'} />
                        ) : null}
                        <img
                          className={'group-badge'}
                          src={`${config.apiUrl}${this.state.group.GroupTheme.badge}`}
                          alt={'groupBadge'}
                        />
                        <input
                          type={'text'}
                          name={'name'}
                          placeholder={__('sim_vul_landnaam_in_placeholder')}
                          value={this.state.group.name.toUpperCase()}
                          onChange={this.handleChange}
                        />
                      </div>
                      {this.props.user.role.indexOf('leader') !== -1 ? (
                        <button className={(this.state.group.avatarLocked && this.state.group.countrynameLocked && ['groupleader', 'groupmember'].includes(this.props.user.role)) ? 'disabled' : ''} type={'submit'} onClick={this.popupBeforeSubmitGroup}>
                          <span>{__('sim_opslaan')}</span>
                        </button>
                      ) : null}
                    </form>
                    {this.state.errorMessage ? (
                      <p style={{ marginTop: '20px', color: 'red', }}>{this.state.errorMessage}</p>
                    ) : null}
                  </ContentContainer>
                  <div className={'table-block'}>
                    {this.props.user.role !== 'classleader' ? null :
                      <Fragment>
                        <SectionHeading
                          className={'small'}
                          questionButton={false}
                          icon={icons.team}
                          title={__('sim_teamleden')} />
                        <Table
                          body={this.renderStudentRows()}
                        />
                      </Fragment>
                    }
                  </div>
                  {this.props.user.role === 'classleader' ? (
                    <button type="submit" onClick={() => {
                      apiCall(`/user/${this.state.group.id}/loginAsGroup`, {}, 'POST')
                        .then((access) => {
                          window.open(`/login?token=${access.token}&redirect=/portal/teaminfo?closeWindow=true`);
                        });
                    }}><span>{__('sim_bekijk_scores')}</span></button>
                  ) : null}
                </div>
              </Scrollbar>
            </div>
            {(this.props.user.role === 'groupleader' || this.props.user.role === 'groupmember') && this.props.project.EducationProject.nameShort === 'GLXL' ? (
              <React.Fragment>
                <div className={'third'}>
                  <Scrollbar style={{ width: '100%', height: '100%', minHeight: 300 }} >
                    <div className={'table-block'}>
                      <SectionHeading
                        className={'small'}
                        questionButton={false}
                        icon={icons.medal}
                        title={__('sim_totaalscores')} />
                      <Table
                        head={[__('sim_spelronde'), __('sim_teaminfo_punten'), __('sim_totaal'), __n('sim_school', 1), __n('sim_klas', 1)]}
                        body={
                          [].concat.apply([], this.prefillScores(this.state.group.Rounds
                            .filter(r => [1, 2, 3, 4].includes(r.roundNumber))
                            .splice(0, roundSpliceIndex)
                            .map((r, i) => {
                              const detailedTotalPoints = [].concat(this.state.group.detailedTotalPoints).splice(0, r.roundNumber);
                              let { verdienen, verdelen } = this.state.group.detailedTotalPoints[i];
                              const bonusPoints = this.props.gameState.Rounds.reduce((bp, round) => {
                                if (Array.isArray(round.GameStates) && r.roundNumber >= round.roundNumber) {
                                  const bonusAssignmentState = round.GameStates.find(g => g.type === 'BONUS_ASSIGNMENT') || { points: 0 };
                                  const teacherInterventionState = round.GameStates.find(g => g.type === 'TEACHER_INTERVENTION') || { points: 0 };
                                  bp += (bonusAssignmentState.points + teacherInterventionState.points);
                                }
                                return bp;
                              }, 0);
                              let verdienenTotal = detailedTotalPoints.reduce((acc, dtp) => {
                                acc += (dtp.verdelen + dtp.verdienen);
                                return acc;
                              }, bonusPoints);
                              verdienenTotal -= verdelen;
                              let verdelenTotal = detailedTotalPoints.reduce((acc, dtp) => {
                                acc += (dtp.verdelen + dtp.verdienen);
                                return acc;
                              }, bonusPoints);
                              const myDetailedRank = this.state.myDetailedRank[i] || {};
                              const verdienenSchoolRank = myDetailedRank.verdienenSchoolRank || 0;
                              const verdelenSchoolRank = myDetailedRank.verdelenSchoolRank || 0;
                              const verdienenSchoolClassRank = myDetailedRank.verdienenSchoolClassRank || 0;
                              const verdelenSchoolClassRank = myDetailedRank.verdelenSchoolClassRank || 0;
                              const scoreArr = [
                                [`${r.roundNumber}. ${__('sim_verdienen')}`, '', '', '', ''],
                                [`${r.roundNumber}. ${__('sim_verdelen')}`, '', '', '', ''],
                              ];
                              if (r.state === 'PLAYING_GAME') {
                                return scoreArr;
                              }
                              if ((r.state.startsWith('SIMULATION_') || r.state === 'END') || (r.state === 'SCORE_SUBMITTED' && r.roundNumber === 1)) {
                                scoreArr[0] = [`${r.roundNumber}. ${__('sim_verdienen')}`, verdienen, verdienenTotal, verdienenSchoolRank, verdienenSchoolClassRank];
                              }
                              const nextRound = this.state.group.Rounds.find(nxtR => nxtR.roundNumber === r.roundNumber + 1);
                              if (nextRound && (nextRound.state.startsWith('SIMULATION_') || nextRound.state === 'END')) {
                                scoreArr[1] = [`${r.roundNumber}. ${__('sim_verdelen')}`, verdelen, verdelenTotal, verdelenSchoolRank, verdelenSchoolClassRank];
                              }
                              return scoreArr;
                            })))
                        }
                        foot={[__('sim_bonuspunten'), `${this.state.group.Rounds.reduce((p, r) => {
                          r.GameStates
                            .filter(gs => gs.type === 'TEACHER_INTERVENTION' || gs.type === 'BONUS_ASSIGNMENT')
                            .forEach(gs => p += gs.points);
                          return p;
                        }, 0) || ''}`, '', '', '']}
                      />
                    </div>
                    <div className={'table-block'}>
                      <SectionHeading
                        className={'small'}
                        questionButton={false}
                        icon={icons.medal}
                        title={`${__('sim_scores_globas_verdienen')}`} />
                      <Table
                        head={[__('sim_spelronde'), __('sim_globas'), __('sim_teaminfo_punten')]}
                        body={this.prefillScoresEarn(this.state.group.Rounds
                          .filter(r => r.GameId)
                          .map((r) => {
                            const { Game } = this.props.schoolClass.SchoolClassGames.find(g => (g.GameId === r.GameId));
                            if (r.state === 'PLAYING_GAME') {
                              return [`${r.roundNumber}. ${Game.name}`, '', ''];
                            }
                            return [`${r.roundNumber}. ${Game.name}`, r.earnedGlobas, r.earnedPoints];
                          }))}
                      />
                    </div>
                  </Scrollbar>
                </div>
                <div className={'third'}>
                  <Scrollbar style={{ width: '100%', height: '100%', minHeight: 300 }} >
                    <div className={'table-block'}>
                      <SectionHeading
                        className={'small'}
                        questionButton={false}
                        icon={icons.medal}
                        title={`${__('sim_scores_globas_verdelen')}`} />
                      <Table
                        translate={false}
                        head={[__('sim_onderdeel'), 'S', 'R1', 'R2', 'R3', 'R4']}
                        className="scores-globas-verdelen-table"
                        body={
                          this.renderTaxScores()
                            .concat(this.renderMinistryScores())
                            .concat(this.props.gameState.gameStateSum.remainingSavingsPoints > 0 ?
                              [[__('sim_overige_spaargeld'), '', '', '', '', this.props.gameState.gameStateSum.remainingSavingsPoints]] :
                              null
                            )
                            .concat(this.props.gameState.gameStateSum.remainingProfitLossPoints !== 0 ?
                              [[__('sim_overige_wgvg'), '', '', '', '', this.props.gameState.gameStateSum.remainingProfitLossPoints]] :
                              null
                            )
                        }
                      />
                    </div>
                  </Scrollbar>
                </div>
              </React.Fragment>
            ) : null}
          </div>
        </div>
        x        {this.state.showPopup ? (
          <PopUp id={this.state.popupId} closePopUpClick={(res) => { this.closePopup(res) }} />
        ) : null}
      </div>
    );
  }
}

export default connect(({ user, project, schoolClass, group, gameState, gameStateInput, feedback }) => ({ user, project, schoolClass, group, gameState, gameStateInput, feedback }))(TeamInfo);



// WEBPACK FOOTER //
// ./src/components/desktop/TeamInfo.js